module.exports = __webpack_public_path__ + "static/media/dashboard-remove-icon.fb0ee42f.svg";